import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const borderColor = '#ccc'
const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: 'row',
        borderBottomColor: '#ccc',
        backgroundColor: '#ccc',
        borderBottomWidth: 1,
        alignItems: 'center',
        height: 20,
        textAlign: 'center',
        fontStyle: 'bold',
        flexGrow: 1,
        fontSize: 12
    },
    description: {
        width: '90%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
    qty: {
        width: '10%',
        borderRightColor: borderColor,
        borderRightWidth: 1,
    },
});

const InvoiceTableHeader = () => (
    <View style={styles.container}>
        <Text style={styles.description}>Equipamentos Emprestados</Text>
        <Text style={styles.qty}>Qnt.</Text>
    </View>
);

export default InvoiceTableHeader